import React, { useEffect } from "react";
import { useProductionStore } from "../../../stores/production";
import { getDepartments } from "../../../api/departments";
import { Select } from "../../ui/inputs/Select";
import { showToastError } from "../../../services/toast";

const Departments = () => {
  const { formData, setFormData, departments, setDepartments } =
    useProductionStore();

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: parseInt(e.target.value) });
  };

  useEffect(() => {
    getDepartments()
      .then((res) => {
        const formattedData = res.data.map((item: any) => ({
          label: item.name,
          value: item.id,
        }));
        setDepartments(formattedData);
      })
      .catch((err) => {
        showToastError(err.response.data.message)     
      });
  }, []);

  return (
    <Select
      label="Departement"
      name="idDepartment"
      value={formData.idDepartment || ""}
      onChange={handleSelectChange}
      fetchOptions={departments}
      className="w-60 font-Nunito"
    />
  );
};

export default Departments;
